/** Independent RTLSDR-Airband 5.x configuration writer. No hardware/network side effects. */
export function receiverConfig(airport: string, carrier: string): { config: string; mountpoint: string; frequency: string } {
  if (!/^[A-Z0-9]{3,4}$/.test(airport)) throw new Error('Choose an airport first.');
  // Restrict this first adapter to actual 25 kHz carriers. 8.33 kHz channel
  // designators are not carrier frequencies and must never be silently rounded.
  if (!/^\d{3}(?:\.\d{1,3})?$/.test(carrier.trim())) throw new Error('Enter the carrier in MHz, such as 123.450.');
  const khz = Math.round(Number(carrier) * 1000);
  if (khz < 118000 || khz > 136975 || khz % 25 !== 0) throw new Error('Use an actual 25 kHz carrier from 118.000 to 136.975 MHz. 8.33 kHz channel designators need a separate receiver setup.');
  const frequency = (khz / 1000).toFixed(3), mountpoint = `${airport.toLowerCase()}-${khz}.mp3`;
  // Offset from the carrier to keep the desired channel away from the SDR DC
  // spike. Only one channel is emitted, with no scanner or recording outputs.
  return { frequency, mountpoint, config: `# Airview Studio receive-only starter for RTLSDR-Airband 5.x.
# Not a live receiver status. Verify the locally published carrier assignment.
# Install Icecast on this receiver host. Set the matching source password here
# on the receiver only; never put it in Airview Studio, a listener URL, or source control.
# Protect this file with chmod 600 before entering a password.
devices: ({
  type = "rtlsdr";
  index = 0;
  gain = 25.0;
  mode = "multichannel";
  sample_rate = 2.56;
  centerfreq = ${((khz + 100) / 1000).toFixed(3)};
  channels: ({
    freq = ${frequency};
    modulation = "am";
    label = "${airport} ${frequency} MHz";
    outputs: ({
      type = "icecast";
      server = "127.0.0.1";
      port = 8000;
      mountpoint = "${mountpoint}";
      username = "source";
      password = "SET_ON_RECEIVER";
    });
  });
});
` };
}
